export default "__VITE_ASSET__KmA4eC1D__"